/**
 * Mental Health Translations Module (Spanish)
 * Matches English structure exactly
 * @module mentalHealth
 * @language es
 */

export const mentalHealth = {
  mentalHealthOld: {
    title: "Índice de Salud Mental",
    subtitle: "Análisis integral de salud mental y bienestar",
    globalAverage: "Promedio Global",
    categoryDistribution: "Distribución de Categorías",
    assessedDimensions: "Dimensiones Evaluadas",
    methodology: "Metodología",
    top5Countries: "Top 5 Países",
    regionalLeaders: "Líderes Regionales",
    leadersByDimension: "Líderes por Dimensión"
  },
  mentalHealthIndex: {
    title: "Índice de Salud Mental",
    subtitle: "Análisis integral de salud mental y bienestar",
    globalAverage: "Promedio Global",
    points: "puntos",
    criticalRisk: "riesgo crítico",
    categoryDistribution: "Distribución de Categorías",
    assessedDimensions: "Dimensiones Evaluadas",
    methodology: "Metodología",
    top5Countries: "Top 5 Países",
    regionalLeaders: "Líderes Regionales",
    leadersByDimension: "Líderes por Dimensión",
    overall: "General",
    youthSuicide: "Suicidio Juvenil",
    serviceAccess: "Acceso a Servicios",
    prevalence: "Prevalencia",
    globalMHIScore: "Puntuación Global MHI",
    coverageNote: "Basado en 114 países JCI",
    lowestRisk: "menor riesgo",
    highestRisk: "mayor riesgo",
    mediumRisk: "riesgo medio",
    regionalRankings: "Índice Regional",
    rank: "Rango",
    region: "Región",
    score: "Puntuación",
    performance: "Rendimiento",
    excellent: "Excelente",
    good: "Bueno",
    moderate: "Moderado",
    concerning: "Preocupante",
    critical: "Crítico"
  },
  mentalHealthPage: {
    pageTitle: "Dimensión de Salud Mental",
    weightInFII: "peso en el FII",
    measuringWellbeing: "Midiendo el bienestar, la resiliencia y el acceso al apoyo en salud mental en todo el mundo.",
    quote: "No hay salud sin salud mental.",
    fiiWeightDistribution: "Distribución de peso del FII",
    mentalHealth: "Salud Mental",
    workforce: "Fuerza laboral",
    entrepreneurship: "Emprendimiento",
    understandCrisis: "Entender la crisis"
  },
  mentalHealth: {
    crisisTitle: "La Crisis de Salud Mental en Números",
    crisisSubtitle: "Estadísticas críticas que afectan el bienestar mental global de los jóvenes",
    crisis: {
      inSeven: "1 de cada 7",
      inSevenSuffix: "de cada 7",
      inThree: "1 de cada 3",
      inThreeSuffix: "de cada 3",
      th: "º",
      stat1Label: "jóvenes globalmente experimentan trastornos de salud mental",
      stat2Label: "tasa de prevalencia de depresión (duplicada desde 8.5% pre-pandemia)",
      stat3Label: "tasa de prevalencia de ansiedad (duplicada desde 11% pre-pandemia)",
      stat4Label: "jóvenes citan inseguridad laboral como principal fuente de ansiedad",
      stat5Label: "jóvenes africanos reportan ansiedad extrema sobre perspectivas laborales",
      stat6Label: "se sienten peor que sus padres en América del Norte, Europa, MENA",
      stat7Label: "acceso promedio global a servicios de salud mental (rango: 10-90%)",
      stat8Label: "causa de muerte entre 15-19 años es el suicidio",
      stat9Label: "de personas con enfermedades mentales no reciben tratamiento"
    },
    severity: {
      crisis: "Crisis",
      severeGap: "Brecha Severa",
      concerning: "Preocupante"
    },
    fiiDimensionTitle: "Dimensión de Salud Mental del FII",
    fiiDimensionSubtitle: "Puntuación de Salud Mental = 40% del Índice de Inversión Futura",
    regions: {
      europe: "Europa",
      americas: "América",
      asiaPacific: "Asia y el Pacífico",
      africaMe: "África y Oriente Medio"
    },
    status: {
      good: "Bueno",
      moderate: "Moderado",
      atRisk: "En Riesgo"
    },
    fii: {
      serviceAccess: "Acceso a Servicios",
      serviceAccessDef: "Porcentaje de 18-40 años con acceso a servicios de salud mental",
      countriesAssessed: "144 países evaluados",
      serviceAccessHighest: "Luxemburgo, Dinamarca, Islandia (80-90%)",
      serviceAccessLowest: "Somalia, Yemen, Chad (<5%)",
      europeNote: "Infraestructura más fuerte",
      americasNote: "Varía por país",
      asiaPacificNote: "Mayor variación",
      africaMeNote: "Brechas críticas",
      serviceAccessFinding: "Acceso ≠ calidad",
      prevalence: "Prevalencia de Trastornos",
      prevalenceDef: "Porcentaje de jóvenes experimentando depresión y/o ansiedad",
      trend1: "Aumento post-COVID: Duplicado desde línea base 2019",
      trend2: "Brecha de género: Mujeres 1.5x-2x tasas más altas",
      trend3: "Concentración de edad: Más alta en grupo 20-24",
      trend4: "Tendencia creciente: Ansiedad +52% aumento (1990-2021)",
      prevalenceFinding: "La prevalencia es relativamente uniforme globalmente, pero el acceso no lo es",
      suicideMortality: "Mortalidad por Suicidio",
      suicideDef: "Tasa de suicidio estandarizada por edad por 100.000 jóvenes (18-40 años)",
      suicideHighest: "Lituania (25-30 por 100k), Rusia (20-25)",
      suicideMiddle: "América del Norte (13-15), Promedio europeo (10-12)",
      suicideLower: "Países asiáticos (5-12, varía ampliamente)",
      suicideLowest: "Países africanos (1.5-5 por 100k, probablemente sub-reportado)",
      suicideCriticalFinding: "Suicidio = 4ª causa de muerte para edades 15-29 (OMS)",
      suicideNote: "Países de bajos ingresos probablemente sub-reportan",
      subWeight: "Sub-peso",
      showDetails: "Mostrar detalles",
      globalAverage: "Promedio global",
      highest: "Más alto",
      lowest: "Más bajo",
      middle: "Medio",
      lower: "Menor",
      regionalBreakdown: "Desglose Regional",
      currentPrevalence: "Prevalencia actual (2021-2025)",
      depression: "Depresión",
      anxiety: "Ansiedad",
      both: "Ambos",
      keyTrends: "Tendencias Clave",
      globalRange: "Rango global",
      keyFinding: "Hallazgo clave",
      criticalFinding: "Hallazgo crítico"
    },
    regionalScoresTitle: "Puntuaciones Regionales de Salud Mental",
    regionalScoresSubtitle: "Dimensión de Salud Mental del FII: Rendimiento Regional",
    regional: {
      serviceAccess: "Acceso a Servicios",
      prevalence: "Prevalencia",
      suicideRate: "Tasa de Suicidio",
      drivers: "Impulsores",
      opportunity: "Oportunidad",
      note: "Nota",
      europeDrivers: "Sistemas de salud universales, programas anti-estigma, integración en el lugar de trabajo",
      europeOpportunity: "Los programas de pares de JCI pueden acelerar caminos de acceso",
      europeNote: "El éxito europeo está impulsado por políticas - los modelos pueden adaptarse globalmente",
      asiaPacificDrivers: "Variación económica: Corea y Japón altos, Sur de Asia bajo",
      asiaPacificOpportunity: "Soluciones de salud mental digital (mobile-first)",
      asiaPacificNote: "El estigma cultural permanece alto - enfoques centrados en jóvenes son clave",
      americasDrivers: "América del Norte fuerte, América Latina tiene grandes brechas",
      americasOpportunity: "RISE centrado en salud mental puede escalarse aquí",
      americasNote: "Altas tasas de suicidio en EE.UU. a pesar del buen acceso = tratamiento ≠ resultados",
      africaMeDrivers: "Escasez de infraestructura, no prevalencia",
      africaMeOpportunity: "Modelos basados en la comunidad que evitan entornos clínicos",
      africaMeNote: "Mayor potencial para asociaciones JCI - modelo de apoyo entre pares es escalable",
      gapLabel: "Brecha"
    },
    gapAnalysis: {
      title: "Análisis de Brecha Regional del FII",
      description: "La brecha entre Europa y África/OM representa la principal desigualdad en la oportunidad global de los jóvenes",
      pointGap: "brecha de puntos",
      comparison: "(Europa 75.28 vs África/OM 53.12)"
    },
    legend: {
      good: "Bueno (70+)",
      moderate: "Moderado (60-69)",
      atRisk: "En Riesgo (<60)"
    },
    riseTitle: "Iniciativas de Salud Mental RISE de JCI",
    riseSubtitle: "Iniciativas de salud mental de JCI alineadas con la brecha de Salud Mental del FII",
    rise: {
      title: "Respuesta de JCI: Proyectos de Salud Mental RISE",
      subtitle: "Escala de Respuesta de Salud Mental de JCI",
      mentalHealthProjects: "Proyectos de Salud Mental",
      ofAllRiseInitiatives: "de todas las iniciativas JCI RISE",
      budgetMobilized: "Presupuesto Movilizado",
      millions: "millones",
      youthTouched: "Jóvenes Tocados",
      programTypes: "Tipos de Programa",
      impact: "Impacto",
      examples: "Ejemplos",
      awarenessName: "Campañas de Concienciación sobre Salud Mental",
      awarenessDesc: "Eventos de educación comunitaria, campañas en redes sociales, asociaciones escolares",
      awarenessImpact: "50.000+ alcanzados directa e indirectamente",
      awarenessEx1: "Eventos 'La Salud Mental Importa'",
      awarenessEx2: "2M+ impresiones en redes sociales",
      awarenessEx3: "Entrenamiento de apoyo entre pares en escuelas",
      peerSupportName: "Redes de Apoyo Entre Pares",
      peerSupportDesc: "Entrenamiento de mentores pares, grupos de apoyo, voluntarios de línea directa de crisis",
      peerSupportImpact: "5.000+ partidarios pares entrenados",
      peerSupportEx1: "Entrenamiento de intervención en crisis",
      peerSupportEx2: "Grupos de apoyo para depresión/ansiedad",
      peerSupportEx3: "Círculos en línea + presenciales",
      crisisTrainingName: "Entrenamiento y Respuesta a Crisis",
      crisisTrainingDesc: "Entrenamiento de primeros respondedores, prevención del suicidio, protocolos de emergencia",
      crisisTrainingImpact: "1.200+ respondedores de crisis entrenados",
      crisisTrainingEx1: "Talleres de prevención del suicidio",
      crisisTrainingEx2: "Primeros auxilios en salud mental",
      crisisTrainingEx3: "Personal de línea directa de emergencia",
      workplaceWellnessName: "Programas de Bienestar en el Lugar de Trabajo",
      workplaceWellnessDesc: "Asociaciones corporativas, entrenamiento de salud mental en el lugar de trabajo, integración EAP",
      workplaceWellnessImpact: "200+ empresas alcanzadas",
      workplaceWellnessEx1: "Talleres de bienestar para empleados",
      workplaceWellnessEx2: "Entrenamiento de salud mental para gerentes",
      workplaceWellnessEx3: "Programas de reducción de estrés",
      regionalDistribution: "Distribución Regional",
      projects: "proyectos",
      distributionNote: "Asia y el Pacífico lidera en proyectos de salud mental. África y Oriente Medio muestra mayor tasa de crecimiento.",
      outcomesMeasured: "Resultados Medidos",
      outcome1: "Aumento de la conciencia sobre salud mental",
      outcome2: "Reducción del estigma en buscar ayuda",
      outcome3: "Conectados a recursos profesionales",
      outcome4: "Reportó mejora en el bienestar",
      crisisInterventions: "intervenciones de crisis realizadas"
    },
    actions: {
      title: "Acciones Recomendadas para JCI",
      subtitle: "Prioridades estratégicas para cerrar la brecha de salud mental",
      effort: "Esfuerzo",
      impactLabel: "Impacto",
      action1Title: "Escalar Proyectos de Salud Mental RISE",
      action1Desc: "Expandir proyectos RISE de salud mental de 22% a 40% de todas las iniciativas, priorizando regiones África/OM",
      action1Effort: "12-18 meses",
      action1Impact: "2x alcance de beneficiarios",
      action2Title: "Entrenar 10.000 Partidarios Pares",
      action2Desc: "Desarrollar currículo de entrenamiento de apoyo entre pares certificado e implementar en todas las regiones para 2030",
      action2Effort: "24-36 meses",
      action2Impact: "Modelo sostenible",
      action3Title: "Expansión de Bienestar en el Lugar de Trabajo",
      action3Desc: "Asociación con patrocinadores corporativos para traer entrenamiento de salud mental a jóvenes profesionales globalmente",
      action3Effort: "6-12 meses",
      action3Impact: "Asociaciones corporativas",
      action4Title: "Plataforma Digital de Salud Mental",
      action4Desc: "Desarrollar recursos de salud mental mobile-first accesibles en todas las regiones JCI",
      action4Effort: "18-24 meses",
      action4Impact: "Accesibilidad global",
      action5Title: "Programa de Embajadores de Salud Mental Comunitaria",
      action5Desc: "Entrenar embajadores de salud mental locales en cada organización local JCI para proporcionar apoyo comunitario continuo",
      action5Effort: "12-24 meses",
      action5Impact: "Escalabilidad de base"
    },
    dataSources: "Fuentes de Datos",
    callToAction: {
      title: "La Salud Mental es la Fundación",
      description: "Los datos son claros: la salud mental es el principal diferenciador entre regiones de alta y baja oportunidad.",
      point1: "La salud mental representa el 40% de la puntuación FII - el mayor factor único",
      point2: "Brecha de 22 puntos entre Europa y África/OM está impulsada principalmente por la infraestructura de salud mental",
      point3: "Los modelos de apoyo entre pares (no clínicos) son ideales para mercados emergentes",
      actionTitle: "Acciones Recomendadas",
      action1: "Escalar proyectos RISE de salud mental en África/OM (actual: 22% de proyectos)",
      action2: "Entrenar 10.000+ partidarios de salud mental entre pares para 2030",
      action3: "Integrar componente de salud mental en todos los programas JCI",
      action4: "Asociarse con OMS y ONGs de salud mental para desarrollo de currículo"
    },
    regionalAnalysis: {
      title: "Análisis Regional del FII: Inmersión Profunda en Salud Mental",
      subtitle: "Desglose detallado de indicadores de salud mental por región JCI",
      europe: {
        strength1: "Puntuación MH general más alta (78/100)",
        strength2: "Cobertura universal de salud mental en países nórdicos",
        strength3: "Programas de salud mental en el lugar de trabajo difundidos",
        strength4: "Bajo estigma en Europa Occidental",
        challenge1: "Sur/Este de Europa se quedan atrás (60-70 puntuaciones)",
        challenge2: "Aislamiento juvenil aumentando post-pandemia",
        challenge3: "Largos tiempos de espera para atención especializada",
        challenge4: "Brechas de acceso rural en algunos países",
        recommendation1: "Aprovechar organizaciones locales de alto rendimiento como modelos",
        recommendation2: "Enfocarse en el aislamiento y la soledad juveniles",
        recommendation3: "Escalar programas de salud mental en el lugar de trabajo",
        insight: "El éxito de Europa está impulsado por políticas - los modelos pueden adaptarse globalmente",
        expansion: "Enfocarse en organizaciones locales del Sur/Este Europeo"
      },
      asiaPacific: {
        strength1: "Rápida adopción de salud mental digital",
        strength2: "Fuertes sistemas de apoyo comunitario/familiar",
        strength3: "Inversión gubernamental aumentando (Japón, Corea, Australia)",
        strength4: "Población joven receptiva a nuevos enfoques",
        challenge1: "Alto estigma en muchas culturas (reduce búsqueda de ayuda)",
        challenge2: "Presión académica/laboral extrema (especialmente Este Asiático)",
        challenge3: "Amplia variación: Australia (75) vs Sur de Asia (45-55)",
        challenge4: "Profesionales capacitados limitados fuera de las grandes ciudades",
        recommendation1: "Soluciones de salud mental digital-first",
        recommendation2: "Campañas anti-estigma centradas en jóvenes",
        recommendation3: "Redes de apoyo entre pares en escuelas/lugares de trabajo",
        insight: "El estigma cultural es la barrera - enfoques centrados en jóvenes son clave",
        expansion: "Escalar salud mental digital en toda la región"
      },
      americas: {
        limitedData: "Datos completos limitados en América Latina",
        strength1: "América del Norte: Acceso fuerte (70-80% cobertura)",
        strength2: "Creciente movimiento de concienciación sobre salud mental",
        strength3: "Expansión de telesalud post-COVID",
        strength4: "Organizaciones de defensa de salud mental activas",
        challenge1: "América Latina: Grandes brechas de acceso (30-50% cobertura)",
        challenge2: "Altas tasas de suicidio en EE.UU. a pesar del buen acceso",
        challenge3: "Barreras de costo en el sistema de salud de EE.UU.",
        challenge4: "Desafíos de acceso rural en toda la región",
        recommendation1: "Enfocarse en la salud mental de América Latina (mayor brecha)",
        recommendation2: "Escalar programas JIB + CYE en naciones de puntuación más baja",
        recommendation3: "Desarrollar programas de apoyo a mujeres emprendedoras",
        insight: "Solo 8% de JCI global pero 15% del mundo = POTENCIAL DE CRECIMIENTO",
        expansion: "Escalar de 90 proyectos RISE → 150+"
      },
      africaMe: {
        limitedData: "Datos completos limitados - muchos estimados",
        strength1: "Población joven: Región más joven (promedio 29 años)",
        strength2: "Aspiración emprendedora: 52% de los jóvenes quieren iniciar negocios",
        strength3: "Potencial de crecimiento: 10-20% crecimiento anual del PIB (algunas regiones)",
        strength4: "Salto digital: Adopción mobile-first",
        challenge1: "Acceso a salud mental: Solo 10-30% cobertura (UE es 70%)",
        challenge2: "Infraestructura de salud: Escasez crítica",
        challenge3: "Desempleo juvenil: 14-16% (global es 13%)",
        challenge4: "Crisis NEET: 1 de cada 3 jóvenes no están en escuela/trabajo",
        challenge5: "Brecha de financiamiento: $1.7T globalmente, 30% África/OM",
        challenge6: "Desigualdad de género: Las mujeres enfrentan 2x barreras en todos los pilares",
        recommendation1: "Salud mental: Modelo de apoyo entre pares (no clínico)",
        recommendation2: "Entrenamiento de habilidades: STEM + digital (vía JCI)",
        recommendation3: "Emprendimiento juvenil: Microfinanzas + mentoría",
        recommendation4: "Empoderamiento de género: Doble enfoque en mujeres",
        insight: "Brecha FII: 22 puntos vs Europa = problema abordable. Proyectos RISE: 220 solo (22%), necesitan escalar 2-3x",
        expansion: "CRÍTICO: Expansión JCI aquí = mayor impacto global. Plan de 3-4 años para cerrar 50% de brecha FII"
      }
    }
  },
  globalTrends: {
    title: "Tendencias Globales de Salud Mental",
    subtitle: "La prevalencia de salud mental ha aumentado más del 25% desde 2020",
    stat1Label: "Aumento en prevalencia de salud mental juvenil",
    stat1Period: "desde 2019",
    stat2Label: "Aumento en tasas de suicidio juvenil",
    stat2Period: "desde 2010",
    stat3Label: "Aumento en uso de servicios de salud mental juvenil",
    stat3Period: "desde 2018",
    globalTrendLabel: "Tendencia Global: Concienciación sobre Salud Mental",
    regionalLabel: "Desglose Regional",
    trendDescription: "La pandemia de COVID-19 exacerbó los desafíos de salud mental, afectando desproporcionadamente a los jóvenes."
  },
  futureOriented: {
    title: "Perspectivas Orientadas al Futuro",
    subtitle: "Proyecciones de salud mental y oportunidades en las regiones JCI",
    trend1: {
      title: "Creciente Prevalencia Globalmente",
      description: "Se proyecta que la depresión y la ansiedad aumenten otro 15% para 2030"
    },
    trend2: {
      title: "Crecimiento de la Salud Mental Digital",
      description: "Se proyecta que la teleterapia y las aplicaciones de salud mental crezcan 100% para 2030"
    },
    trend3: {
      title: "Enfoque en la Salud Mental en el Lugar de Trabajo",
      description: "Los empleadores aumentan la inversión en el bienestar de los empleados"
    },
    trend4: {
      title: "Apoyo Entre Pares Liderado por Jóvenes",
      description: "Los modelos de apoyo entre pares demuestran ser escalables y culturalmente relevantes"
    }
  }
} as const;
